export const routeUrl = (path) =>
  `${path}`;